import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ToggleButtonProps {
  title: string;
  isOpened: boolean;
  handleToggle: () => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  title,
  isOpened,
  handleToggle,
}) => {
  return (
    <Button
      type="button"
      variant="outline"
      className="justify-between !px-4 border-neutral-200"
      onClick={handleToggle}
    >
      <h2 className="text-violet text-sm font-normal">{title}</h2>

      {isOpened ? (
        <ChevronUp className="w-4 h-4" />
      ) : (
        <ChevronDown className="w-4 h-4" />
      )}
    </Button>
  );
};
